import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/lib/guards';

export const Route = createFileRoute('/_staff-fullscreen')({
  beforeLoad: (ctx) => {
    requireAuth({ location: { pathname: ctx.location.pathname } });
  },
  component: FullscreenLayout,
});

function FullscreenLayout() {
  return <Outlet />;
}
